import logo from '../../assets/images/head_logo.svg';
import { StyledContainer } from './BankLogo.styled';

const BankLogo: React.FC = () => {
	return (
		<StyledContainer>
			<img src={logo} />
			{/* <StyledSettingsButton
				onMouseEnter={() => setPopupVisible(true)}
				onMouseLeave={() => setPopupVisible(false)}
			>
				<StyledSettingIcon />
			</StyledSettingsButton> */}
			{/* <CSSTransition
				in={popupVisible}
				classNames={'popup'}
				timeout={300}
				unmountOnExit
			>
				<StyledPopup text={'Настройки недоступны'} />
			</CSSTransition> */}
		</StyledContainer>
	);
};

export { BankLogo };
